export default __webpack_public_path__ + "static/firefox-9c8a567664abc95ce23f6e1f68aff938.svg";